import "./styles.scss";
import axios from "axios";
import { useState, useEffect } from "react";
import { CTA } from "@merchstores/shared/elements/Cta";
import { SortDropdown } from "@merchstores/shared/elements/SortDropdown";
import { Table } from "@merchstores/shared/elements/Table";
import { Checkbox } from "@merchstores/shared/elements/Checkbox";
import { useCallback } from "react";
import { MerchStoreMemberListProps } from ".";
import { InviteMerchStoreMember } from "../InviteMerchStoreMember";
import { MemberListAdminHeader } from "./MemberListAdminHeader";

export const MerchStoreMemberList = (props: MerchStoreMemberListProps) => {
  const [membersList, setMembersList] = useState(undefined);
  const [membersTableData, setMembersTableData] = useState(undefined);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [orderError, setOrderError] = useState(false);
  const { merchStore, setMerchStoreDetails, fetchMembers, uniqueId, handleSubmissionEditOpen, memberAndSubmissionDetails, setSortOptionChosen } = props;

  const onAddMembers = () => {
    fetchMembers(uniqueId);
  }

  const memberCheckboxChanged = useCallback((newValue: boolean, id: string) => {
    let newSelectedMembers = selectedMembers;
    if (newValue) {
      newSelectedMembers = newSelectedMembers.concat(id);
    }
    else {
      newSelectedMembers = newSelectedMembers.filter((m: string) => m !== id);
    }
    setSelectedMembers(newSelectedMembers)
  }, [selectedMembers])

  const selectAllChanged = (newValue: boolean, id: string) => {
    if (newValue) {
      const allMemberIds = membersList.map((m: any) => m.memberCode);
      setSelectedMembers(allMemberIds);
    }
    else {
      setSelectedMembers([]);
    }
  }

  const onDeleteClick = () => {
    const deleteConfirmation = window.confirm("Are you sure to delete these members?");
    if (deleteConfirmation) {
      axios.post('/.netlify/functions/deleteMerchStoreMembers', {
        // TODO: pass real member Ids
        memberIds: selectedMembers
      })
        .then(res => {
          if (res.status === 200) {
            fetchMembers(uniqueId);
            setSelectedMembers([]);
          } else {
            alert(`An error ocurred deleting the member, please try again.`);
          }
        })
        .catch(err => {
          alert(`An error ocurred deleting the member, please try again.`);
          console.error('An error ocurred deleting the member:', err);
        })
    }
  }

  useEffect(() => {
    setMembersList(memberAndSubmissionDetails)
  }, [merchStore.groupOrderId, merchStore.storeCode, fetchMembers])

  useEffect(() => {
    if (membersList && membersList.length === memberAndSubmissionDetails.length) {
      const membersTableData = membersList.map((member: any) => {
        if (memberAndSubmissionDetails) {
          memberAndSubmissionDetails.every((memberWithSubmission: any) => {
            if (memberWithSubmission.submissionId === member.submissionId) {
              member.submission = memberWithSubmission.submission;
              return false;
            } else {
              return true;
            }
          })
        }
        return {
          tr: {
            class: "",
            data: {
              memberSelector: {
                desktopOnly: false,
                value: <Checkbox isSelected={selectedMembers.includes(member.memberCode)} id={member.memberCode} className={`member-checkbox ${selectedMembers.includes(member.memberCode) ? 'seleccionado' : ''}`} onChange={memberCheckboxChanged} />
              },
              memberEmail: {
                desktopOnly: false,
                value: member.email
              },
              memberId: {
                desktopOnly: false,
                value: <div className="mr-4">{member.memberCode}</div>
              }
            }
          }
        }
      });
      setMembersTableData(membersTableData);
    }
  }, [membersList, selectedMembers, memberAndSubmissionDetails, handleSubmissionEditOpen, memberCheckboxChanged])

  const sortOptions =
    [
      {
        title: "Member Name A - Z",
        id: "name_a-z",
        action: () => {
          setSortOptionChosen('nameDesc')
        }
      },
      {
        title: "Member Name Z - A",
        id: "name_z-a",
        action: () => {
          setSortOptionChosen('nameAsc')
        }
      }
    ]
  
  return (
    <div >
      <InviteMerchStoreMember order={merchStore} memberAndSubmissionDetails={props.memberAndSubmissionDetails} display={props.showAddMember} onMembersAdded={props.onMembersAdded}/>
      <MemberListAdminHeader merchStore={merchStore} setMerchStoreDetails={setMerchStoreDetails}/>
      {orderError ? (
        <h3>TODO: BUILD AN ERROR VIEW</h3>
      ) : (
        membersTableData ?
          <>
            {membersTableData.length > 0 &&
            <>
            <div className={"flex justify-between align-center items-start dropdowns-container px-4 md:px-0"}>
              <div><p className="font-bold">Members</p></div>
              <div className="sort-orders-container"><SortDropdown title="Sort" list={sortOptions} defaultSort="name_a-z" /></div>
            </div>
            <div className="flex mb-10 h-30">
              <Checkbox isSelected={selectedMembers && selectedMembers.length > 0} label={selectedMembers && selectedMembers.length > 0 ? `${selectedMembers.length} selected` : 'Select all'} className="member-checkbox items-center" onChange={selectAllChanged} />
              {selectedMembers && selectedMembers.length > 0 ? <CTA type="secondary" size="small" onClick={onDeleteClick}>Delete</CTA> : ''}
            </div>
            </>
            }
            <div className='member-list-container'>
              <Table name="member-list" filter={true} data={membersTableData} itemsName="members" />
            </div>
          </>
          : ''
      )
      }
    </div>
  )
}
